var map = {
	"./ico-arrow-right.vue": 844,
	"./ico-arrow.vue": 846,
	"./ico-checkbox-selected.vue": 848,
	"./ico-checkbox-unselected.vue": 850,
	"./ico-circle-cancel.vue": 852,
	"./ico-circle-information.vue": 854,
	"./ico-circle-plus-outline.vue": 856,
	"./ico-circle-plus.vue": 858,
	"./ico-code.vue": 860,
	"./ico-cross.vue": 862,
	"./ico-customers.vue": 864,
	"./ico-double-arrows.vue": 866,
	"./ico-drag.vue": 868,
	"./ico-export.vue": 870,
	"./ico-help.vue": 872,
	"./ico-hint.vue": 874,
	"./ico-icons.vue": 876,
	"./ico-images.vue": 878,
	"./ico-import.vue": 880,
	"./ico-locked-padlock.vue": 882,
	"./ico-loupe.vue": 884,
	"./ico-mobile-vertical-dots.vue": 886,
	"./ico-note.vue": 888,
	"./ico-notes.vue": 890,
	"./ico-orders.vue": 892,
	"./ico-products.vue": 894,
	"./ico-radio-selected.vue": 896,
	"./ico-radio-unselected.vue": 898,
	"./ico-spinner-big.vue": 900,
	"./ico-spinner.vue": 902,
	"./ico-success.vue": 904,
	"./ico-text-block-2.vue": 906,
	"./ico-text-block.vue": 908,
	"./ico-tools.vue": 910,
	"./ico-trash.vue": 912,
	"./ico-view.vue": 914,
	"./ico-warning.vue": 916
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 843;


//////////////////
// WEBPACK FOOTER
// ./src/components/base/icons nonrecursive \w+\.(vue)$
// module id = 843
// module chunks = 0